// extracted by mini-css-extract-plugin
export default {"lock":"Lock_lock__2+Tib","small":"Lock_small__RDiTq","medium":"Lock_medium__TLC2g","free":"Lock_free__69E-I"};